import { useEffect, useState } from "react";
import { useTournamentContext } from "../../../../hook/context";
import * as S from "./styles";
import * as C from "../base/style";
import ImageDropzone from "../../../../../../component/ImageDropZone";

export const EditTournamentReservation = () => {
  const {
    isReservation,
    setIsReservation,
    reservationImage,
    setReservationImage,
  } = useTournamentContext();
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);

  useEffect(() => {
    if (reservationImage) {
      if (typeof reservationImage === "string") {
        setPreviewUrl(reservationImage);
      } else if (reservationImage instanceof File) {
        const url = URL.createObjectURL(reservationImage);
        setPreviewUrl(url);
        return () => {
          URL.revokeObjectURL(url);
        };
      }
    } else {
      setPreviewUrl(null);
    }
  }, [reservationImage]);
  return (
    <C.EditTournamentBaseWrapper>
      <C.EditTournamentBaseContent $isRow={true}>
        <div className="title">예약 생성</div>
        <S.EditTournamentReservationToggle
          isOn={isReservation}
          onClick={() => setIsReservation(!isReservation)}
        >
          <S.EditTournamentReservationToggleCircle isOn={isReservation} />
        </S.EditTournamentReservationToggle>
      </C.EditTournamentBaseContent>
      {isReservation && (
        <C.EditTournamentBaseContent>
          <div className="title">예약 이미지</div>
          <div className="description">
            포스터 이미지를 올려주세요!
            <br />
            최소 400 x 400, 최대 1600 x 1600
          </div>
          <S.EditTournamentReservationInputContent>
            <ImageDropzone
              onImageUpload={setReservationImage}
              defaultUrl={previewUrl || ""}
            >
              <S.EditTournamentReservationImageDrop>
                <div className="icon">
                  <img src="/image-web/edit/upload.svg" alt="Initial content" />
                </div>
                <div className="content">
                  <div className="title">이미지 업로드</div>
                  <div className="description">클릭하여 파일 선택</div>
                </div>
              </S.EditTournamentReservationImageDrop>
            </ImageDropzone>
          </S.EditTournamentReservationInputContent>
        </C.EditTournamentBaseContent>
      )}
    </C.EditTournamentBaseWrapper>
  );
};
